@if (creq$ | async; as creq) {
	<cm-key-val-list>
		<div cm-key-val>
			<cm-localize kv-key [name]="locs.SPUploadConfirmationFieldLabelActiveDate" [cpName]="locs.CPUploadConfirmationFieldLabelActiveDate"/>
			<span>{{ creq.activeDate | cmDate }}</span>
		</div>
		<div cm-key-val *ngIf="isSP">
			<cm-localize kv-key [name]="locs.SPUploadConfirmationFieldLabelExpireDate" [cpName]="locs.CPUploadConfirmationFieldLabelExpireDate"/>
			@if (creq.expireDate) {
				<span >{{ creq.expireDate | cmDate }}</span>
			} @else{
				<cm-localize [name]="locs.SPUploadConfirmationTextNever" [cpName]="locs.CPUploadConfirmationTextNever"/>
			}
		</div>
		<div cm-key-val *ngIf="creq.provider">
			<cm-localize kv-key [name]="locs.SPUploadConfirmationFieldLabelProvider" [cpName]="locs.CPUploadConfirmationFieldLabelProvider"/>
			<span>{{ creq.provider}}</span>
		</div>
		<div cm-key-val *ngIf="creq.langName">
			<cm-localize kv-key [name]="locs.SPUploadConfirmationFieldLabelDocLanguage" [cpName]="locs.CPUploadConfirmationFieldLabelDocLanguage"/>
			<span>{{ creq.langName }}</span>
		</div>

		@if (creq.certRequirementCatalogDetail; as crcatDetail) {
			<div cm-key-val *ngIf="crcatDetail.factorUnits">
				<span kv-key>
					{{crcatDetail.factorUnits}}
				</span>
				<span *ngIf="crcatDetail?.factor > 0">
					{{creq?.points / crcatDetail.factor }}
				</span>
				<span *ngIf="!(crcatDetail?.factor)">
					{{creq?.points }}
				</span>
			</div>

			<div cm-key-val *ngIf="creq?.points || creq?.points === 0">
				<cm-localize kv-key [name]="locs.SPUploadConfirmationFieldLabelFactorNotFound" [cpName]="locs.CPUploadConfirmationFieldLabelFactorNotFound"/>
				<span>
					{{creq.points }}
				</span>
			</div>
		}

		<div cm-key-val *ngIf="creq.certRequirementCatalogDetail?.docRequired !== null" [boolean]="!!creq.docUrl"
			[downloadUrl]="creq.docUrl" downloadTargetWindow="_blank">
			<cm-localize kv-key [name]="locs.SPUploadConfirmationFieldLabelDocumentation" [cpName]="locs.CPUploadConfirmationFieldLabelDocumentation"/>
		</div>
		<div cm-key-val *ngIf="creq.docNotes && !!creq.docNotes.length" class="span-all">
			<cm-localize kv-key [name]="locs.SPUploadConfirmationFieldLabelDocNotes" [cpName]="locs.CPUploadConfirmationFieldLabelDocNotes"/>
			<pre>{{ creq.docNotes }}</pre>
		</div>
	</cm-key-val-list>

}


<div class="stepper-actions">
	<button mat-raised-button color="primary" (click)="startOver()">
		<cm-localize [name]="locs.SPUploadConfirmationButtonStepThreeStartOver" [cpName]="locs.CPUploadConfirmationButtonStepThreeStartOver"/>
	</button>
</div>
